import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import * as Icons from "lucide-react";
import { motion } from "framer-motion";
import { revealItem } from "@/components/Reveal";

const FEASIBILITY_STYLES = {
  1: { label: "Easy DIY", cls: "bg-duckgreen/15 text-forest" },
  2: { label: "Moderate", cls: "bg-terracotta/15 text-terracotta" },
  3: { label: "Often a pro job", cls: "bg-forest/10 text-forest" },
};

export default function PestCard({ pest }) {
  const Icon = Icons[pest.icon] || Icons.Bug;
  const feas = FEASIBILITY_STYLES[pest.feasibilityLevel] || FEASIBILITY_STYLES[2];
  return (
    <motion.div variants={revealItem}>
      <Link
        to={`/pests/${pest.slug}`}
        className="group relative flex flex-col h-full overflow-hidden rounded-3xl bg-card border border-forest/10 hover:border-forest/20 transition-all hover:shadow-xl hover:shadow-forest/5 hover:-translate-y-1 duration-300"
        data-testid={`pest-card-${pest.slug}`}
      >
        <div className="relative h-40 overflow-hidden">
          <img
            src={pest.cardImage}
            alt={`${pest.name} — ${pest.short}`}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-forest-950/50 to-transparent" />
          <span
            className={`absolute top-3 left-3 px-3 py-1 rounded-full text-[11px] font-mono font-medium ${feas.cls} bg-cream/95`}
          >
            {feas.label}
          </span>
          <div className="absolute bottom-3 left-3 w-11 h-11 rounded-2xl bg-cream/95 flex items-center justify-center">
            <Icon className="w-5 h-5 text-forest" style={{ color: pest.accent }} />
          </div>
        </div>
        <div className="flex flex-col flex-1 p-6">
          <h3 className="font-serif text-xl font-bold text-forest-950 group-hover:text-terracotta transition-colors">
            {pest.name}
          </h3>
          <p className="mt-2 text-sm text-forest-950/70 leading-relaxed flex-1">{pest.short}</p>
          <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-forest">
            Explore
            <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </span>
        </div>
      </Link>
    </motion.div>
  );
}
